import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import API from "utils/API";
import moment from "moment";
import ReactStrapTable from "components/reactStrapTable";

let isHaveColFilter = false;

const ReferralFile = ({ onDataLoading }) => {
  let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: "",
    order: "",
    filters: [],
  };
  const { patientId, tenantID } = useParams();
  const [data, setData] = useState([]);
  const [totalSize, setTotalSize] = useState(0);
  const [initFilter, setInitFilter] = useState(initialFilters);

  const fetchReferrals = async (filters = {}) => {
    onDataLoading(true);
    try {
      const { data } = await API.post(
        `/${tenantID}/Referral/Patient/${parseInt(patientId)}`,
        filters
      );
      if (data) {
        setData(data.items);
        setTotalSize(data.totalRecords);
      }
      onDataLoading(false);
    } catch (error) {
      onDataLoading(false);
    }
  };

  useEffect(() => {
    fetchReferrals(initFilter);
  }, []);

  const dateFormate = (row, columnName) => {
    return (
      <>
        {row[columnName]
          ? moment(new Date(row[columnName])).format("MM/DD/YYYY")
          : "-"}
      </>
    );
  };

  const formatter = (row, columnName) => {
    return <>{row[columnName] || "-"}</>;
  };

  const columns = [
    {
      dataField: "patientFirstName",
      text: "Patient First Name",
      width: 120,
      sort: true,
      cellRenderer: (row) => formatter(row, "patientFirstName"),
      inputType: "text",
    },
    {
      dataField: "patientLastName",
      text: "Patient Last Name",
      width: 120,
      sort: true,
      cellRenderer: (row) => formatter(row, "patientLastName"),
      inputType: "text",
    },
    {
      dataField: "patientDOB",
      text: "Patient Date of Birth",
      width: 120,
      cellRenderer: (row) => dateFormate(row, "patientDOB"),
      inputType: "date",
    },
    {
      dataField: "medicalRecordNumber",
      text: "Medical Record Number",
      width: 120,
      cellRenderer: (row) => formatter(row, "medicalRecordNumber"),
      inputType: "number",
    },
    {
      dataField: "referralDate",
      text: "Referral Date",
      width: 120,
      cellRenderer: (row) => dateFormate(row, "referralDate"),
      inputType: "date",
    },
    {
      dataField: "referralSpecialty",
      text: "Referral Specialty",
      width: 140,
      cellRenderer: (row) => formatter(row, "referralSpecialty"),
      inputType: "date",
    },
    {
      dataField: "referralReason",
      text: "Referral Reason",
      width: 120,
      cellRenderer: (row) => formatter(row, "referralReason"),
      inputType: "date",
    },
    {
      dataField: "encounterDate",
      text: "Encounter Date",
      width: 120,
      cellRenderer: (row) => dateFormate(row, "encounterDate"),
      inputType: "date",
    },
    {
      dataField: "referringProviderNPI",
      text: "Referring Provider NPI",
      width: 140,
      cellRenderer: (row) => formatter(row, "referringProviderNPI"),
      inputType: "text",
    },
    {
      dataField: "referringProviderFirstName",
      text: "Referring Provider First Name",
      width: 140,
      cellRenderer: (row) => formatter(row, "referringProviderFirstName"),
      inputType: "text",
    },
    {
      dataField: "referringProviderLastName",
      text: "Referring Provider Last Name",
      width: 140,
      cellRenderer: (row) => formatter(row, "referringProviderLastName"),
      inputType: "text",
    },
    {
      dataField: "referralProviderNPI",
      text: "Referral Provider NPI",
      width: 140,
      cellRenderer: (row) => formatter(row, "referralProviderNPI"),
      inputType: "text",
    },
    {
      dataField: "referralProviderFirstName",
      text: "Referral Provider First Name",
      width: 140,
      cellRenderer: (row) => formatter(row, "referralProviderFirstName"),
      inputType: "text",
    },
    {
      dataField: "referralProviderLastName",
      text: "Referral Provider Last Name",
      width: 140,
      cellRenderer: (row) => formatter(row, "referralProviderLastName"),
      inputType: "text",
    },
    {
      dataField: "referralProviderPracticeName",
      text: "Practice Name",
      width: 140,
      cellRenderer: (row) => formatter(row, "referralProviderPracticeName"),
      inputType: "text",
    },
    {
      dataField: "referralProviderPracticePhone",
      text: "Practice Phone#",
      width: 140,
      cellRenderer: (row) => formatter(row, "referralProviderPracticePhone"),
      inputType: "text",
    },
    {
      dataField: "referralProviderPracticeFax",
      text: "Practice Fax#",
      width: 140,
      cellRenderer: (row) => formatter(row, "referralProviderPracticeFax"),
      inputType: "text",
    },
  ];

  const handlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      let filter = { ...filter, filters: [...colChangedFilter] };
      fetchReferrals(filter, true);
      setInitFilter(filter);
    } else {
      setInitFilter(filter);
      fetchReferrals(filter);
    }
  };

  const handleSort = (filter) => {
    setInitFilter(filter);
    fetchReferrals(filter);
  };

  const handleSearchColumnFilters = (columnFilters) => {
    if (columnFilters.length) {
      let filter = {
        ...initFilter,
        filters: [...columnFilters],
        currentPage: 1,
      };
      fetchReferrals(filter, true);
      setInitFilter(filter);
    }
  };

  const handleFilterCancel = () => {
    let filters = { ...initFilter, filters: [] };
    fetchReferrals(filters);
    setInitFilter(filters);
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setInitFilter(filter);
      let colFilterOn = { ...filter, filters: colChangedFilter };
      return fetchReferrals(colFilterOn, true);
    } else {
      setInitFilter(filter);
      fetchReferrals(filter);
    }
  };

  return (
    <div className="table-card scroll-table position-relative border-0">
      <ReactStrapTable
        id="refferrals"
        height={50 * data.length}
        fixedColumn
        columns={columns}
        data={data}
        handleSort={handleSort}
        onSearchColumnFilters={handleSearchColumnFilters}
        onFilterCancel={handleFilterCancel}
        pageSize={initFilter.pageSize}
        onPageSizeChange={onPageSizeChange}
        hasPagination
        currentPage={initFilter.currentPage}
        totalRecords={totalSize}
        onPageChange={handlePageChange}
        filters={initFilter}
      />
    </div>
  );
};

export default ReferralFile;
